module.exports = Object.freeze([{
  id: "owner",
  name: "Owner"
},{
  id: "admin",
  name: "Administrator"
},{
  id: "member",
  name: "Member"
}]);